import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import SchedulerDashboard from "./pages/SchedulerDashboard";
import USTechnicianDashboard from "./pages/USTechnicianDashboard";
import CTechnicianDashboard from "./pages/CTechnicianDashboard";
import PrivateRoute from "./components/PrivateRoute";
import ContactInfo from "./pages/ContactInfo";
import Materials from "./pages/Material";
import Newsboard from "./pages/Newsboard";

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {/* Dashboard route chooses correct component based on user role */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardWrapper />
            </PrivateRoute>
          }
        />

        {/* Other private routes */}
        <Route
          path="/stinte/material_information"
          element={
            <PrivateRoute>
              <Materials />
            </PrivateRoute>
          }
        />
        <Route path="/contact_info" element={<ContactInfo />} />
        <Route path="/newsboard" element={<Newsboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

// Helper component to choose dashboard
function DashboardWrapper() {
  const user = JSON.parse(sessionStorage.getItem("user"));
  if (!user) return <div>Loading...</div>;

  if (user.role === "Scheduler") {
    return <SchedulerDashboard />;
  }

  if (user.role === "USTechnician") {
    return <USTechnicianDashboard />;
  }

  if (user.role === "CTechnician") {
    return <CTechnicianDashboard />;
  }

  return <div>No dashboard available for this role.</div>;
}

